export default "__VITE_ASSET__u9d1JnyR__"